import { render } from "./HomeBody.vue?vue&type=template&id=09acd23c"
import script from "./HomeBody.vue?vue&type=script&lang=js"
export * from "./HomeBody.vue?vue&type=script&lang=js"

import exportComponent from "/home/mw/Code/hc-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__